import React, { useEffect, useState } from "react";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader.jsx";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader.jsx";
import { Input } from "../../../stories/Input/Input.jsx";
import { Row, Col, Container } from "react-bootstrap";
import classes from "./ServiceSideMaintenance.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { ServerSide500, logoColor } from "../../../constant/imagePath";
import { Button } from "../../../stories/Button/Button.jsx";
import { useHistory } from "react-router-dom";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook.js";
import ServerSideMaintenanceMobile from "./ServiceSideMaintenanceMobile.js";

function ServerSideMaintenanceDesktop() {
  const history = useHistory();
  return (
    <div
      className={classes.serverSide}
      style={{ backgroundColor: Colors.white }}
    >
      <Container fluid className="p-0">
        <Row>
          <BeforeLoginHeader icon={logoColor} text1="" text2="" />
          <Col md={12}>
            <div className={classes.mainContent}>
              <img src={ServerSide500} />
              <h3 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
                Internal server error
              </h3>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>
                There is a problem with the resource you are looking for, and it
                cannot be displayed
              </p>
            </div>
          </Col>
          <Col md={12}>
            <div className={classes.btns}>
              <Button
                label={"Back to home"}
                primary={true}
                onClick={() => history.push("/")}
                size={"Large"}
                customStyle={{
                  maxWidth: "max-content",
                  marginLeft: "16px",
                  padding: "12px 32px 12px 32px",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default function ServerSideMaintenance() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  return isMobile ? (
    <ServerSideMaintenanceMobile />
  ) : (
    <ServerSideMaintenanceDesktop />
  );
}
